import React from "react";
import StatsSection from "../Home-stats";
import Testimonial from  '../Testimonials.jsx'
const About = () => {
  // Data for the cards
  const cardData = [
    {
      imgSrc: "../images/abt2.jpg",
      title: "Driven by Innovation, Focused on Results",
      description: "We don’t just follow trends we help set them. From custom websites and mobile apps to intuitive UI/UX design and scalable digital marketing strategies, we deliver solutions that are creative, data driven, and results focused. Every project is built around your business goals, ensuring you get measurable outcomes and long term value.",
    },
    {
      imgSrc: "../images/abt3.jpg",
      title: "A Team That Thinks Like Entrepreneurs",
      description: "What sets us apart is our mindset. We're more than developers and designers we're strategic thinkers who understand business. Our team brings together creativity, technical expertise, and deep industry insights to help you not only build, but grow. Whether you're a startup or an established brand, we think like partners who are invested in your success. ",
    },
    {
      imgSrc: "../images/abt4.jpg",
      title: "Built on Trust, Powered by Experience",
      description: "With years of hands on experience and a portfolio that spans multiple industries, we’ve earned a reputation for delivering quality work on time, every time. Our clients stay with us because we prioritize transparency, collaboration, and results. From initial consultation to final delivery, we make your journey smooth, strategic, and successful.",
    },
  ];

  return (
    <>
      <div className="mx-auto w-full max-w-7xl py-8 pb-0 md:py-16 px-4">
         <div className="text-center mb-4 md:mb-4">
            <span className="text-4xl font-bold mb-4 text-center text-black border-b-2 border-[#E12126] uppercase">
              About Werkeron
            </span>
            <p className="text-balance mt-4 text-gray-900">We are a digital agency, passionate about building and designing brands.</p>
          </div>
        <div
                className={`block md:flex gap-8 md:grid-cols-2 md:gap-24 items-center`}
                >
                  
                {/* Left or Right Content depending on the index */}
                <div className="max-w-4xl">
                  
                <span className="text-black border-b-2 border-[#E12126] uppercase"></span>
                  <p className="text-regular text-gray-900 mt-2 md:mt-4 mb-2  text-balance">
                 Since our inception, we have been dedicated to helping businesses uncover innovative, results-driven solutions that elevate their presence and performance in the digital world. From launching memorable brands to developing cutting-edge websites, mobile apps, and marketing strategies, our mission has always been to empower clients with tools that drive growth and long-term success.
<br></br>
<br></br>

With each passing year, our expertise has expanded both in depth and scope. We’ve worked across diverse industries, allowing us to accumulate a wealth of knowledge and real-world experience that informs every project we undertake. Whether it's strategic business consultation, graphic design, or full scale digital transformation, we approach every challenge with a commitment to quality, creativity, and measurable outcomes.
<br></br>
<br></br>
What sets us apart is not just what we do, but how we do it with passion, precision, and a client-centric mindset. We don’t just build brands or digital products; we build relationships, ensuring every solution we provide is tailored, scalable, and future ready.
                  </p>
                </div>

                {/* Right or Left Image depending on the index */}
                <div className="h-full">
                  <img
                    src="../images/abt1.jpg"
                    alt="Image"
                    className="bg-gray-200 shadow-box shadow-gray-500/30 overflow-hidden aspect-square w-full h-full object-cover object-center"
                  />
                </div>
              </div>
        <div className="py-8">
        <StatsSection />
        </div>
        {/* Mission & Goal Section */}
      <section className="grid grid-cols-1 md:grid-cols-2 gap-8 py-4 mb-12">
        <div className="flex flex-col">
           <span className="text-xl max-w-max font-bold mb-4 text-left font-semibold text-black border-b-2 border-[#E12126] uppercase">
              Our Mission
            </span>
          <p className=" text-gray-900 mt-2">
           Our mission is to empower businesses with innovative, high impact digital solutions that drive growth, enhance brand value, and deliver measurable results. We strive to bridge the gap between creativity and technology building meaningful digital experiences through custom web and app development, intuitive design, strategic marketing, and expert business consultation.
<br></br>
<br></br>
We are committed to helping our clients not only adapt to change but lead it, by delivering scalable, future ready solutions tailored to their unique needs.
          </p>
        </div>
        <div className="flex flex-col">
          <span className="text-xl max-w-max font-bold mb-4 text-left font-semibold text-black border-b-2 border-[#E12126] uppercase">
              Our Goal
            </span>
            <p className=" text-gray-900 mt-2 mb-4">
          Our goal is to become a trusted partner for businesses worldwide, known for excellence, integrity, and results. We aim to:
        </p>
        <ul className="list-disc pl-6 space-y-4 ">
          <li>
            Deliver <span className="font-semibold text-gray-900">user centric digital products</span> that are both visually compelling and functionally powerful.
          </li>
          <li>
            Provide <span className="font-semibold text-gray-900">end-to-end business solutions</span>, from initial strategy to final execution.
          </li>
          <li>
            Stay ahead of industry trends to ensure our clients always receive <span className="font-semibold text-gray-900">innovative and competitive services</span>.
          </li>
          <li>
            Cultivate long term relationships by focusing on <span className="font-semibold text-gray-900">client success, satisfaction, and ROI</span>.
          </li>
          <li>
            Foster a culture of <span className="font-semibold text-gray-900">continuous improvement, creativity, and collaboration</span> within our team.
          </li>
        </ul>
        </div>
      </section>

        {/* Cards Section */}
        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-8">
          {cardData.map((card, index) => (
            <div key={index} className="rounded overflow-hidden flex flex-col max-w-xl mx-auto">
                <img className="w-full max-h-[250px] object-cover object-center" src={card.imgSrc} alt={card.title} />
              <div className="relative -mt-8 px-4 pt-5 pb-4 bg-white m-2">
                <p
                  className="font-semibold text-lg inline-block hover:text-indigo-600 transition duration-500 ease-in-out inline-block mb-2"
                >
                  {card.title}
                </p>
                <p className="text-gray-500 text-sm">{card.description}</p>     
              </div>
            </div>
          ))}
        </div>
      </div>
      <Testimonial/>
    </>
  );
};

export default About;
